import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const GiftPage = ({
    accessToken,
    submitActionType,
    submitPayload,
    wizards,
    WizardRedux,
    wizardsRemoved,
    onComponentDidMount,
}) => {
    const [wizardsDidReset, setWizardsDidReset] = useState(false)

    useEffect(() => {
        onComponentDidMount()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (wizardsRemoved && !wizardsDidReset) {
            setWizardsDidReset(true)
        }
    }, [wizardsRemoved]) // eslint-disable-line react-hooks/exhaustive-deps

    if (!wizardsDidReset && Object.keys(wizards).length !== 0) {
        return null
    }

    return (
        <WizardRedux.Wrapper
            submitActionType={submitActionType}
            submitPayload={submitPayload}
            id="GiftWizard"
        >
            <WizardRedux.StepRoute
                url="/offer"
                as="/offer"
            />
            {!accessToken && (
                <WizardRedux.StepRoute
                    url="/login"
                    as="/login"
                />
            )}
            <WizardRedux.StepRoute
                method={!accessToken ? 'replace' : 'push'}
                url="/gift-form"
                as="/gift-form"
            />
            <WizardRedux.StepRoute
                method="replace"
                url="/finalize-payment"
                as="/finalize-payment"
            />
        </WizardRedux.Wrapper>
    )
}

GiftPage.propTypes = {
    accessToken: PropTypes.string.isRequired,
    submitActionType: PropTypes.string.isRequired,
    submitPayload: PropTypes.object.isRequired,
    wizards: PropTypes.object.isRequired,
    onComponentDidMount: PropTypes.func.isRequired,
    wizardsRemoved: PropTypes.bool.isRequired,
    WizardRedux: PropTypes.shape({
        Wrapper: PropTypes.element,
        StepRoute: PropTypes.element,
    }).isRequired,
}

export default React.memo(GiftPage)
